// extracted by mini-css-extract-plugin
export var colorSquare = "_tq-0";
export var danger = "_tq-5";
export var lightPink = "_tq-8";
export var neutralBlue = "_tq-7";
export var neutralYellow = "_tq-6";
export var normal = "_tq-1";
export var primary = "_tq-2";
export var primaryLight = "_tq-3";
export var solidBlack = "_tq-g";
export var solidGreen = "_tq-b";
export var solidLightBlue = "_tq-d";
export var solidNavy = "_tq-c";
export var solidOrange = "_tq-f";
export var solidPink = "_tq-e";
export var solidRed = "_tq-9";
export var solidYellow = "_tq-a";
export var success = "_tq-4";